// extracted by mini-css-extract-plugin
export var button = "_hd-2";
export var card = "_hd-0";
export var closeButtonContainer = "_hd-3";
export var iconContainer = "_hd-1";